// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1gUlm","footer":"ModalUpdate_footer__2pG6s"};